// src/admin/ProtectedRoute.js
import React from "react";
import { Navigate } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { FaSpinner } from "react-icons/fa";

const ProtectedRoute = ({ children }) => {
  const { user, loading } = useAuth();

  if (loading) {
    return (
      <div
        style={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          color: "var(--text-2)",
          gap: "0.75rem",
          fontFamily: "var(--font-display)",
        }}
      >
        <FaSpinner
          className="spin"
          size={20}
          style={{ animation: "spin 0.8s linear infinite" }}
        />
        Loading…
      </div>
    );
  }

  return user ? children : <Navigate to="/admin" replace />;
};

export default ProtectedRoute;
